module.exports = __webpack_public_path__ + "static/media/book.602f7fff.png";